import { ReportFeatures } from '@hcs/types';

export const DEFAULT_TAGS = [
  'Fair Market Value Match',
  'After Repair Value Match',
];

export const COMP_TAGS_FEATURES = [ReportFeatures.Tags];
